// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
export class VerticalDetailsItemProps {
}
export class VerticalDetailsItemComponentView {
}
export class VerticalDetailsItemViewModel extends AbstractViewModel {
    get rowName() {
        return this.componentView.rowName;
    }
    set rowName(value) {
        this.updateComponentView('rowName', value);
    }
    get rowNameTooltip() {
        return this.componentView.rowNameTooltip;
    }
    set rowNameTooltip(value) {
        this.updateComponentView('rowNameTooltip', value);
    }
    get rowValueTooltip() {
        return this.componentView.rowValueTooltip;
    }
    set rowValueTooltip(value) {
        this.updateComponentView('rowValueTooltip', value);
    }
    get firstRowValue() {
        return this.componentView.firstRowValue;
    }
    set firstRowValue(value) {
        this.updateComponentView('firstRowValue', value);
    }
    get secondRowValue() {
        return this.componentView.secondRowValue;
    }
    set secondRowValue(value) {
        this.updateComponentView('secondRowValue', value);
    }
    get firstValueColor() {
        return this.componentView.firstValueColor;
    }
    set firstValueColor(value) {
        this.updateComponentView('firstValueColor', value);
    }
    get secondValueColor() {
        return this.componentView.secondValueColor;
    }
    set secondValueColor(value) {
        this.updateComponentView('secondValueColor', value);
    }
    constructor() {
        super(VerticalDetailsItemComponentView);
        this.item = null;
        this.setDataRow = () => {
            const rowName = this.item.getItemName();
            const rowNameTooltip = this.item.getItemTooltip();
            const values = this.item.getItemValue();
            const colors = this.item.getItemColor();
            this.rowName = rowName;
            this.rowNameTooltip = rowNameTooltip;
            this.rowValueTooltip = values.toString();
            this.firstRowValue = values.firstValue;
            this.secondRowValue = values.secondValue;
            this.firstValueColor = colors.firstValue;
            this.secondValueColor = colors.secondValue;
        };
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        this.setItemRow(props.row);
    }
    update(props) {
        super.update(props);
        if (this.props.row !== props.row) {
            this.setItemRow(props.row);
        }
        this.props = props;
    }
    dispose() {
        this.item.unsubscribeOnUpDateEmit(this.setDataRow);
        super.dispose();
    }
    onMouseDown(event) {
        const typePointer = this.item.getTypePointer();
        this.props.accountDetailsItemDown(event, typePointer);
        ControlsUtils.Capture.SetCapture(this, event);
    }
    onMouseMove(event) {
        this.props.accountDetailsItemMove(event);
    }
    onMouseUp(event) {
        this.props.accountDetailsItemUp(event);
    }
    setItemRow(value) {
        if (isNullOrUndefined(value)) {
            return;
        }
        this.item = value;
        this.item.subscribeOnUpDateEmit(this.setDataRow);
        this.setDataRow();
    }
}
